import { render, staticRenderFns } from "./send-push-modal.vue?vue&type=template&id=87dd2516&scoped=true&"
import script from "./send-push-modal.vue?vue&type=script&lang=ts&"
export * from "./send-push-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dd2516",
  null
  
)

export default component.exports